import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=5b3b6976&scoped=true&"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=5b3b6976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b6976",
  null
  
)

export default component.exports